<mat-card *ngIf="postState?.deleted">
  This post was probably deleted by the author.
</mat-card>

<mat-card *ngIf="!postState?.deleted">
  <div class="d-flex">
    <!-- Profile Picture -->
    <div class="tl-tooltip-wrap tl-no-focus">
      <div class="pr-cursor">
        <img imageLoader loader="./assets/images/profile.jpg" onErrorSrc="./assets/images/profile.jpg"
          [src]="postState?.post?.author?.photoURL?.trim()" alt="avatar" class="tl-profile pr-cursor"
          (mouseenter)="showProfileCard()" [routerLink]="['/', postState?.post?.author?.handle]" />
      </div>
      <div class="tl-tooltip-content" *ngIf="showProfileCardEvent$ | async">
        <anms-profile-card [lightUser]="postState?.post?.author" [currentUser]="currentUser$ | async">
        </anms-profile-card>
      </div>
    </div>
    <!-- Name -->
    <div>
      <div class="pr-cursor tl-tooltip-wrap tl-no-focus" [routerLink]="['/', postState?.post?.author?.handle]">
        <span class="tl-name mr-1">{{postState?.post?.author?.name}}</span>
        <span class="tl-username text-success tl-truncate">@{{postState?.post?.author?.handle}}</span>
      </div>
      <!-- Published Date -->
      <div class="tl-date">
        <i class="fas fa-clock mr-1"></i>
        <span>
          <!--  May 1, 2020. 10:00 AM-->
          {{postState?.post?.lastEdited | postTime}}
        </span>
      </div>
    </div>
    <div class="ml-auto">
      <button mat-icon-button [matMenuTriggerFor]="actions" style="color: rgba(0, 0, 0, 0.26);">
        <mat-icon>more_vert</mat-icon>
      </button>

      <mat-menu #actions="matMenu" xPosition="before">
        <div *ngIf="currentUser$ | async as currentUser">
          <button mat-menu-item *ngIf="currentUser?.handle && currentUser?.handle === postState?.post?.author?.handle"
            (click)="deletePost()">
            <mat-icon>delete</mat-icon>
            <span>Delete</span>
          </button>
          <button mat-menu-item *ngIf="currentUser?.handle && currentUser?.handle != postState?.post?.author?.handle"
            (click)="reportPost()">
            <mat-icon>report_problem</mat-icon>
            <span>Report</span>
          </button>
        </div>
        <button mat-menu-item *ngIf="false">
          <mat-icon>share</mat-icon>
          <span>Share</span>
        </button>
      </mat-menu>
    </div>
  </div>

  <!-- Post Content -->
  <div class="border-bottom" *ngIf="postState?.post?.postType !== 'POLL'">
    <h5 class="tl-title pr-cursor" (click)="postClicked($event)">{{postState?.post?.articleContent?.title}}</h5>
    <p *ngIf="postState?.post?.postType !== 'POLL'" class="tl-post pr-cursor">
      <read-article class="wrap-overflow">
        <markdown ngPreserveWhitespaces *ngIf="postState?.post" (click)="postClicked($event)">
          {{parseBody(postState?.post?.body).body}}
        </markdown>
      </read-article>
    </p>

    <preview-url *ngIf="lastUrl" [url]="lastUrl"></preview-url>

    <!--    <ng-container>-->
    <!--      <ngx-link-preview class="modern"-->
    <!--                        [links]="['https://en.wikipedia.org/wiki/Kenya']"-->
    <!--                        [apiRoute]="'https://play.dhis2.org/demo/api/metadata'"-->
    <!--                        [getApiEndpoint$]="apiCallbackFn">-->
    <!--        <h2>Here can be your custom loading spinner</h2>-->
    <!--      </ngx-link-preview>-->
    <!--    </ng-container>-->

    <!--    used video player-->
    <!--    https://www.freakyjolly.com/angular-video-player-using-videogular2-with-customized-controls/#.X77A3FkzajA-->
    <div>
      <vg-player *ngFor="let v of postState?.post?.videos" class="overlay-container">
        <video #media [vgMedia]="media" id="singleVideo" preload="auto" controls>
          <source [src]="v?.url" type="video/mp4">
        </video>
        <div class="overlay-btn" (click)="upVotePost()" *ngIf="(currentUser$ | async)?.ID === null">
          <button mat-fab color="primary" aria-label="Login to Play" style="margin-bottom: 25px">
            <mat-icon>play_arrow</mat-icon>
          </button>
        </div>
      </vg-player>
    </div>


    <div class="pr-cursor" [class.img-wrapper]="postState?.post?.images?.length > 1"
      [class.img-wrapper3]="postState?.post?.images?.length === 3">
      <img class="img-size img-single" *ngFor="let photo of postState?.post?.images; index as i" imageLoader
        loader="./assets/images/default-loading.jpg" onErrorSrc="./assets/images/loading.gif" [src]="photo?.url.trim()"
        alt="post image" width="100%" (click)="open(i)" />
    </div>

    <div class="pr-cursor" [class.img-wrapper]="postState?.post?.images?.length > 1"
      [class.img-wrapper3]="postState?.post?.images?.length === 3">
      <img class="img-size img-single"
        *ngFor="let photo of (postState?.post && parseBody(postState?.post?.body).images); index as i" imageLoader
        loader="./assets/images/default-loading.jpg" onErrorSrc="./assets/images/loading.gif" [src]="photo"
        alt="post image" width="100%" (click)="open(i)" />
    </div>
  </div>

  <!--  end of post content-->
  <!--  echo design-->
  <div *ngIf="postState?.post?.postType === 'ECHO'">
    <reposted-post [echoModel]="postState?.post?.echoContent?.originalPost" (click)="postReportClicked($event)"
      class="pr-cursor tl-echo"></reposted-post>
  </div>
  <!-- end echo design-->

  <!--  poll design - section-->
  <div class="border-bottom" *ngIf="postState?.post?.postType === 'POLL'">
    <!-- <h5 class="tl-title">Conditional Post Title - For Blog Posts Only</h5> -->
    <p class="tl-post pr-cursor" (click)="postClicked($event)">
      {{postState?.post?.pollContent?.question}}
    </p>
    <!-- Poll -->
    <!-- On CLick It Should Display Poll Results -->
    <div class="tl-poll-vote">
      <mat-radio-group aria-label="Select an option" class="tl-poll-group"
        *ngIf="!(postState?.post?.pollContent?.expiry | pollExpired) && (postState?.post?.myPollVote === null)">
        <mat-radio-button value="{{i}}" class="tl-poll-button"
          *ngFor="let answer of postState?.post?.pollContent?.answers; let i = index" (click)="castForPoll(i)">
          {{answer.answer}}
        </mat-radio-button>
      </mat-radio-group>
    </div>
    <!-- Poll Results - To Be Activated by Voting -->
    <div class="tl-poll-results"
      *ngIf="(postState?.post?.myPollVote !== null) || (postState?.post?.pollContent?.expiry | pollExpired)">
      <div class="d-flex tl-poll" *ngFor="let answer of postState?.post?.pollContent?.answers; let i = index">
        <span class="tl-poll-percentage">{{answer.votes | pollCalculatePercentage :
          postState?.post?.pollContent?.totalVotes}}
          %</span>
        <div class="tl-poll-bar">
          <span class="tl-poll-option">{{answer?.answer}}</span>
          <mat-progress-bar mode="determinate"
            [value]="answer.votes | pollCalculatePercentage : postState?.post?.pollContent?.totalVotes"
            class="tl-poll-display"></mat-progress-bar>
        </div>
        <span matTooltip="You voted for this" matTooltipPosition="before" *ngIf="postState?.post?.myPollVote === i">
          <i class="fa fa-check-circle tl-voted" color="accent"></i></span>
      </div>
    </div>

    <div class="tl-poll-meta">
      <i class="fas fa-users mr-1"></i>
      <span>{{postState?.post?.pollContent?.totalVotes}} Votes</span>
      <i class="fas fa-stopwatch mr-1 ml-1"></i>
      <span>{{postState?.post?.pollContent?.expiry | pollCountDown}}</span>
    </div>
  </div>

  <!--  end of poll design-->


  <!-- Reactions Sections -->
  <div class="d-flex justify-content-between tl-reactions">
    <div>
      <button mat-icon-button aria-label="Comment" matTooltip="Comment" [disabled]="postState?.showComments"
        (click)="showComments()">
        <mat-icon>comment</mat-icon>
      </button>
      <small>{{postState?.post?.engagement?.commentCount}}</small>

      <button mat-icon-button aria-label="Favorite" matTooltip="Favorite" (click)="favouritePost()"
        *ngIf="!postState?.post?.isFavorited">
        <mat-icon>favorite_border</mat-icon>
      </button>

      <button mat-icon-button aria-label="Favorite" matTooltip="Favorite" (click)="unFavouritePost()"
        *ngIf="postState?.post?.isFavorited">
        <mat-icon color="accent">favorite</mat-icon>
      </button>

      <small>{{postState?.post?.engagement?.favorited}}</small>

      <span *ngIf="postState?.post?.postType !== 'ECHO'">
        <button matTooltip="Rescribe" mat-icon-button [matMenuTriggerFor]="echo">
          <mat-icon>cached</mat-icon>
        </button>
        <mat-menu #echo="matMenu">
          <button mat-menu-item (click)="echoWithoutComment()">
            <mat-icon>cached</mat-icon>
            <span>Rescribe</span>
          </button>
          <button mat-menu-item (click)="echoPost()">
            <mat-icon>format_quote</mat-icon>
            <span>Quote</span>
          </button>
        </mat-menu>
        <small>{{postState?.post?.engagement?.echoes}}</small>
      </span>
      <button mat-icon-button *ngIf="postState?.post?.postType === 'ECHO'" matTooltip="Rescribed">
        <mat-icon color="primary">cached</mat-icon>
      </button>
    </div>
    <div>
      <button mat-icon-button aria-label="Upvote" matTooltip="Upvote" matTooltipPosition="below" (click)="upVotePost()"
        *ngIf="postState?.post?.myVote === 'NONE' || postState?.post?.myVote !== 'UPVOTE'">
        <mat-icon fontSet="material-icons-outlined">thumb_up</mat-icon>
      </button>
      <button mat-icon-button aria-label="unVote" color="primary" matTooltip="unVote" matTooltipPosition="below"
        (click)="unVotePost()" *ngIf="postState?.post?.myVote === 'UPVOTE'">
        <mat-icon>thumb_up</mat-icon>
      </button>
      <small>{{postState?.post?.engagement?.upVotes - postState?.post?.engagement?.downVotes}}</small>
      <button mat-icon-button aria-label="Downvote" matTooltip="Downvote" matTooltipPosition="below"
        (click)="downVotePost()" *ngIf="postState?.post?.myVote === 'NONE' || postState?.post?.myVote !== 'DOWNVOTE'">
        <mat-icon fontSet="material-icons-outlined">thumb_down</mat-icon>
      </button>
      <button mat-icon-button aria-label="unVote" color="accent" matTooltip="unVote" matTooltipPosition="below"
        (click)="unVotePost()" *ngIf="postState?.post?.myVote === 'DOWNVOTE'">
        <mat-icon>thumb_down</mat-icon>
      </button>
      <span>
        <button matTooltip="Share" mat-icon-button [matMenuTriggerFor]="share">
          <mat-icon style="font-size: 20px;">share</mat-icon>
        </button>
        <mat-menu #share="matMenu" xPosition="before">
          <a mat-icon-button matTooltip="Facebook" target="_blank"
            href="http://www.facebook.com/sharer/sharer.php?u=https://gscroll.com/{{postState?.post?.author.handle}}/post/{{postState.post.Id}}&t={{parseBody(postState?.post?.body).body}}">
            <i class="fab fa-facebook fa-lg" style="color:#4267B2;"></i>
          </a>
          <a mat-icon-button matTooltip="Twitter" target="_blank"
            href="http://www.twitter.com/intent/tweet?url=https://gscroll.com/{{postState?.post?.author.handle}}/post/{{postState.post.Id}}&via=GScroll_Social&text={{parseBody(postState?.post?.body).body.trim()}}">
            <i class="fab fa-twitter fa-lg" style="color:#1DA1F2;"></i>
          </a>
          <a mat-icon-button matTooltip="WhatsApp" target="_blank"
            href="https://wa.me/?text=https://gscroll.com/{{postState?.post?.author.handle}}/post/{{postState.post.Id}}/{{postState?.post?.body}}">
            <i class="fab fa-whatsapp fa-lg" style="color:#25D366;"></i>
          </a>
          <a mat-icon-button matTooltip="Telegram" target="_blank"
            href="https://t.me/share/url?url=https://gscroll.com/{{postState?.post?.author.handle}}/post/{{postState.post.Id}}&text={{parseBody(postState?.post?.body).body}}">
            <i class="fab fa-telegram fa-lg" style="color:#0088cc;"></i>
          </a>
          <button mat-icon-button matTooltip="Copy Link" (click)="openSnackBar('Link copied to clipboard!', '')" 
            ngxClipboard cbContent="https://gscroll.com/{{postState?.post?.author.handle}}/post/{{postState.post.Id}}">
            <mat-icon>insert_link</mat-icon>
          </button>
          <!-- <a mat-icon-button matTooltip="Other" target="_blank"
            href="{{postState?.post?.author.handle}}/post/{{postState.post.Id}}">
            <mat-icon style="font-size: 20px;">send</mat-icon>
          </a> -->
        </mat-menu>
        <!-- <small>{{postState?.post?.engagement?.echoes}}</small> -->
      </span>
    </div>
  </div>

  <div>
    <div class="d-flex justify-content-center" *ngIf="postState?.commentCursor?.hasNextPage && !hideActionButtons">
      <!-- <button mat-icon-button [matMenuTriggerFor]="sort" matTooltip="Sort" *ngIf="false">
        <mat-icon>sort</mat-icon>
      </button>
      <mat-menu #sort="matMenu">
        <button mat-menu-item>
          <span>Newest</span>
        </button>
        <button mat-menu-item>
          <span>Oldest</span>
        </button>
      </mat-menu> -->
      <button mat-button (click)="loadMoreComments()" matTooltip="Load More">
        Load More
        <mat-icon>unfold_more</mat-icon>
      </button>
    </div>
    <div infiniteScroll [fromRoot]="true" [infiniteScrollContainer]="'mat-sidenav-content'" [infiniteScrollDistance]="2"
      (scrolled)="scrollComments()">

      <!-- Begin Comment -->
      <div *ngIf="postState.showComments" class="tl-post-comments">
        <anms-comment *ngFor="let commentState of postState.commentsState" [commentState]="commentState"
          (upVote)="upVoteComment(commentState?.comment?.Id)" (deleteAction)="deleteComment($event)"
          (downVote)="downVoteComment(commentState?.comment?.Id)" [currentUser]="currentUser$ | async"
          (showReplyCommentEvent)="showReplyComment($event)" (createReplyCommentEvent)="createReplyComment($event)"
          (hideCommentsEvent)="hideReplyComments(commentState?.comment?.Id)"
          (loadMoreReplyCommentsEvent)="loadMoreReplyComments(commentState?.comment?.Id)"
          (downVoteReplyCommentEvent)="downVoteReplyComment($event)"
          (upVoteReplyCommentEvent)="upVoteReplyComment($event)" (deleteReplyCommentEvent)="deleteReplyComment($event)">
        </anms-comment>
      </div>
      <!-- End Comment -->
    </div>
    <form *ngIf="postState.showComments" [formGroup]="commentGroup" novalidate>
      <div class="d-flex justify-content comments-area">
        <div class="cp-mobile">
          <img [src]="(currentUser$ | async)?.profileData?.photoURL || './assets/images/profile.jpg'" alt="avatar"
            class="tl-profile-pc pr-cursor">
        </div>

        <div class="tl-full-width my-2">

          <mat-form-field class="tl-full-width" appearance="standard">
            <mat-label>Add Comment</mat-label>
            <mat-post-input formControlName="comment" [outsideContent]="emojiEvent"></mat-post-input>
            <div matSuffix class="d-flex justify-content-end">
              <button mat-icon-button matTooltip="Add GIF" #gifEmojiTrigger="matMenuTrigger"
                [matMenuTriggerFor]="giphyMenu">
                <mat-icon color="primary">gif</mat-icon>
              </button>

              <button mat-icon-button matTooltip="Insert emoji" [matMenuTriggerFor]="emojiMenu">
                <mat-icon class="sun-yellow">insert_emoticon</mat-icon>
              </button>
            </div>
          </mat-form-field>

          <mat-menu #emojiMenu="matMenu" xPosition="before">
            <emoji-mart class="emoji-mart" set="{{set}}" (emojiSelect)="addEmoji($event)"
              (click)="$event.stopPropagation()" title="Pick an emoji"></emoji-mart>
          </mat-menu>


          <mat-menu #giphyMenu="matMenu" xPosition="before">
            <anms-giphy (click)="$event.stopPropagation()" (selectedGiphy)="selectedGiphy($event)"></anms-giphy>
          </mat-menu>


          <div class="d-flex justify-content-between post-comment">
            <button mat-button class="text-muted" (click)="hideComments()" *ngIf="!hideActionButtons" matTooltip="Hide">
              Hide
              <mat-icon>expand_less</mat-icon>
            </button>
            <button mat-button color="primary"
              [disabled]="!commentGroup?.valid || (currentUser$ | async)?.handle === null" (click)="createComment()">
              Post
              <mat-icon>keyboard_arrow_right</mat-icon>
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>

</mat-card>